<template>
    <div>
		
        <div class="site-navigation container-fluid">

            <button type="button" class="mobile-menu-toggle" id="MobileMenuToggle" aria-expanded="false">
                <span class="mobile-menu-toggle__hamburger">
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
                <span class="mobile-menu-toggle__close">
                    <span></span>
                    <span></span>
                </span>
                <span class="sr-only">Toggle Mobile Menu</span>
            </button>

            <div class="site-logo" v-if="siteNavigation.logo">
                <a :href="siteNavigation.logo.linkURL">
                    <img class="mobile-logo" :src="siteNavigation.logo.mobile.path" :alt="siteNavigation.logo.mobile.alt">
                    <img class="desktop-logo" :src="siteNavigation.logo.desktop.path" :alt="siteNavigation.logo.desktop.alt">
                </a>
            </div>



            <nav class="primary-menu" id="PrimaryMenu" aria-label="Primary Navigation">
			
                <ul class="primary-menu__list">
                    <li class="primary-menu__item" :class="{ 'primary-menu__item--has-sub': item.secondaryMenu }" :key="item.id" v-for="(item, index) in siteNavigation.nav">

                        <a v-if="!item.secondaryMenu" class="primary-menu__link" href="/">{{ item.title }}</a>
                        <button v-else type="button" class="primary-menu__toggle preventScroll" :aria-expanded="item.active ? 'true' : 'false'" :aria-controls="`PrimaryMenu-${index}`" :id="`PrimaryBtn-${index}`">{{ item.title }}</button>

                        <div class="secondary-menu" :class="{ active: item.active }" v-if="item.secondaryMenu" :id="`PrimaryMenu-${index}`">

                            <button type="button" class="return-to-primary-menu">
                                <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 257.6 451.8" xml:space="preserve">
                                <path d="M14.2,204.5L200.5,18.2c11.9-11.9,31.1-11.9,42.9,0c11.8,11.8,11.8,31.1,0,42.9L78.6,226l164.8,164.8 c11.9,11.9,11.9,31.1,0,42.9c-11.8,11.9-31,11.9-42.9,0L14.2,247.4c-5.9-5.9-8.9-13.7-8.9-21.4C5.3,218.2,8.3,210.4,14.2,204.5z" />
							    </svg>
                                Back
                            </button>

                            <a class="current-page-label" :href="item.link ? item.link.linkURL : '#'">{{ item.title }}</a>

                            <ul class="icon-menu" v-if="item.iconMenu">
                                <li :key="icon.id" v-for="icon in item.iconMenu">
                                    <a href="/">
                                        <div class="icon-callout">
                                            <div class="frame" :style="'background-image:url(' + icon.path + ');'"></div>
                                            <div class="button-label">
                                                {{ icon.title }}
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>

                            <ul class="secondary-menu__list">

                                <li class="secondary-menu__item" :class="{ 'secondary-menu__item--has-sub': subitem.links && subitem.links.length > 0 }" :key="subitem.id" v-for="(subitem, subIndex) in item.secondaryMenu">

                                    <a v-if="!subitem.links || subitem.links.length === 0" class="secondary-menu__link" :href="subitem.seeAllLink ? subitem.seeAllLink.linkURL : '#'">{{ subitem.title }}</a>
                                    <button v-else type="button" class="secondary-menu__toggle preventScroll" aria-expanded="false" :aria-controls="`PrimaryMenu-${index}_SecondaryMenu-${subIndex}`" :id="`PrimaryBtn-${index}_SecondaryBtn-${subIndex}`">
                                        {{ subitem.title }}
                                    </button>

                                    <div v-if="subitem.links" class="tertiary-menu" :id="`PrimaryMenu-${index}_SecondaryMenu-${subIndex}`">

                                        <button type="button" class="return-to-primary-menu">
                                            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 257.6 451.8" xml:space="preserve">
                                            <path d="M14.2,204.5L200.5,18.2c11.9-11.9,31.1-11.9,42.9,0c11.8,11.8,11.8,31.1,0,42.9L78.6,226l164.8,164.8 c11.9,11.9,11.9,31.1,0,42.9c-11.8,11.9-31,11.9-42.9,0L14.2,247.4c-5.9-5.9-8.9-13.7-8.9-21.4C5.3,218.2,8.3,210.4,14.2,204.5z" />
                                            </svg>
                                            Back
                                        </button>

                                        <a class="current-page-label" :href="subitem.seeAllLink ? subitem.seeAllLink.linkURL : '#'">
                                            {{ subitem.title }}
                                        </a>

                                        <ul class="tertiary-menu__list">
                                            <li class="tertiary-menu__item" :class="{ 'external-link': link.externalLink }" :key="link.id" v-for="link in subitem.links.slice(0, 8)">
                                                <a :href="link.linkURL">{{ link.linkText }}</a>
                                            </li>
                                        </ul>
                                    </div>

                                    <a class="see-all" v-if="subitem.seeAllLink" :href="subitem.seeAllLink.linkURL">
                                        {{ subitem.seeAllLink.linkText }}
                                        <svg class="icon-arrow-right" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve">
                                            <path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z" />
									    </svg>
                                    </a>

                                </li>
                            </ul>

                            <a class="see-all-link" v-if="item.secondaryMenuPageLink" :href="item.secondaryMenuPageLink.linkURL">
                                {{ item.secondaryMenuPageLink.linkText }}
                                <svg class="icon-arrow-right" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 257.6 451.8" xml:space="preserve">
                                <path d="M243.4,247.4L57.1,433.7c-11.9,11.9-31.1,11.9-42.9,0c-11.8-11.8-11.8-31.1,0-42.9L179,225.9L14.2,61.1 C2.3,49.2,2.3,30,14.2,18.2C26,6.3,45.2,6.3,57.1,18.2l186.3,186.3c5.9,5.9,8.9,13.7,8.9,21.4C252.3,233.7,249.3,241.5,243.4,247.4 z" />
							    </svg>
                            </a>
                        </div>
                    </li>

                    <li class="primary-menu__item primary-menu__item--mobile-utility-nav">
                        <div class="mobile-utility-nav">
                            <ul class="mobile-utility-nav__list">
                                <li class="mobile-utility-nav__item" :key="item.id" v-for="item in utilityNav.nav">
                                    <a :href="item.linkURL">{{ item.linkText }}</a>
                                </li>
                            </ul>
                        </div>
                    </li>

                    <li class="primary-menu__item primary-menu__item--mobile-contact-social">
                        <div class="mobile-contact-social">
                            <ul class="mobile-contact-social__list">
                                <li class="mobile-contact-social__item">
                                    <button type="button" class="mobile-contact-social__toggle" aria-expanded="false" aria-controls="accordionMobileSocial" id="btnMobileSocial" js-mobile-social-toggle>
                                        Follow Us
                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 433.4 247" xml:space="preserve"><path d="M195.8,234.8L14.9,53.9c-11.6-11.6-11.6-30.2,0-41.7c11.5-11.5,30.2-11.5,41.7,0l160.1,160l160-160 c11.6-11.6,30.2-11.6,41.7,0c11.6,11.5,11.6,30.1,0,41.7L237.5,234.8c-5.7,5.7-13.3,8.6-20.8,8.6 C209.1,243.5,201.6,240.5,195.8,234.8z"></path></svg>
                                    </button>
                                    <div class="mobile-contact-social__accordion-content" id="accordionMobileSocial">
                                        <div class="social-icons">
                                            <a :key="icon.id" v-for="icon in siteNavigation.socialIcons" :href="icon.link.linkURL">
                                                <img :src="icon.icon">
                                            </a>
                                        </div>
                                    </div>
                                </li>
                                <li class="mobile-contact-social__item">
                                    <button type="button" class="mobile-contact-social__toggle" aria-expanded="false" aria-controls="accordionMobileContact" id="btnMobileContact" js-mobile-social-toggle>
                                        Contact Us
                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 433.4 247" xml:space="preserve"><path d="M195.8,234.8L14.9,53.9c-11.6-11.6-11.6-30.2,0-41.7c11.5-11.5,30.2-11.5,41.7,0l160.1,160l160-160 c11.6-11.6,30.2-11.6,41.7,0c11.6,11.5,11.6,30.1,0,41.7L237.5,234.8c-5.7,5.7-13.3,8.6-20.8,8.6 C209.1,243.5,201.6,240.5,195.8,234.8z"></path></svg>
                                    </button>
                                    <div class="mobile-contact-social__accordion-content" id="accordionMobileContact">
                                        <div class="contact">
                                            Contact RTE Content Goes Here
                                        </div>
                                    </div>
                                </li>
                                <li class="mobile-contact-social__item mobile-contact-social__item--language-selector" js-mobile-language-selector></li>
                            </ul>
                        </div>
                    </li>

                </ul>
            </nav>
        
            <button type="button" class="header-search-toggle" id="headerSearchToggle" aria-expanded="false" aria-controls="headerSearchRegion">
                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="22px" height="23px" viewBox="0 0 22 23" version="1.1">
                    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="Navigation/-Desktop-" transform="translate(-1374.000000, -85.000000)" fill-rule="nonzero">
                            <g id="Main-Nav" transform="translate(0.000000, 55.000000)">
                                <g id="Search" transform="translate(1386.500000, 43.000000) rotate(-45.000000) translate(-1386.500000, -43.000000) translate(1379.000000, 30.000000)">
                                    <path d="M6.1981931,17.863208 L8.98080179,17.863208 L8.98080179,24.1240776 C8.98080179,24.8924737 8.35789362,25.5153819 7.58949744,25.5153819 L7.58949744,25.5153819 C6.82110127,25.5153819 6.1981931,24.8924737 6.1981931,24.1240776 L6.1981931,17.863208 Z" id="Rectangle" fill="#097EC2" />
                                    <circle id="Oval" stroke="#097EC2" stroke-width="2" cx="7.83544763" cy="7.44837333" r="7" />
                                </g>
                            </g>
                        </g>
                    </g>
                </svg>
                <span class="sr-only">Toggle Search</span>
            </button>
        </div>
    
        <div class="header-search" id="headerSearchRegion">
            <form class="search container-fluid" action="#" method="post">
                <input id="siteSearch" class="siteSearch" type="text" placeholder="I need help finding...">
            </form>
        </div>
    </div>	
</template>

<script>
	
	import UtilityNav from './UtilityNav.vue';
	
	export default {
		name: 'SiteNavigation',

		props: ['siteNavigation', 'utilityNav'],
		
		components: {
			UtilityNav
		}
	}
	
</script>